{
  "title": "Geas",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level enchantment",
  "level": 5,
  "castingTime": "1 minute",
  "range": "60 feet",
  "components": "V",
  "duration": "30 days",
  "description": [
    "You place a magical command on a creature that you can see within range, forcing it to carry out some service or refrain from some action or course of activity as you decide.",
    "If the creature can understand you, it must succeed on a Wisdom saving throw or become charmed by you for the duration. While the creature is charmed by you, it takes 5d10 psychic damage each time it acts in a manner directly counter to your instructions, but no more than once each day. A creature that can’t understand you is unaffected by the spell.",
    "You can issue any command you choose, short of an activity that would result in certain death. Should you issue a suicidal command, the spell ends. You can end the spell early by using an action to dismiss it. A Remove Curse, Greater Restoration, or Wish spell also ends it.",
    "At Higher Levels. When you cast this spell using a spell slot of 7th or 8th level, the duration is 1 year. When you cast this spell using a spell slot of 9th level, the spell lasts until it is ended by one of the spells mentioned above."
  ],
  "spellLists": ["bard", "cleric", "druid", "paladin", "wizard"]
}
